/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiEmptyResponseFromJSON, ApiListResponseSafeguardGroupFilterResponseFromJSON, ApiResponseQuickStartSafeguardListResponseFromJSON, ApiResponseSafeguardBulkSaveResponseFromJSON, ApiResponseSafeguardDetailsResponseFromJSON, ApiResponseSafeguardListResponseFromJSON, SafeguardBulkSaveRequestToJSON, UpdateSafeguardAttributeValueRequestToJSON, } from '../models';
/**
 *
 */
export class SafeguardControllerApi extends runtime.BaseAPI {
    /**
     */
    quickStartSafeguardListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling quickStartSafeguardList.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling quickStartSafeguardList.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/safeguards/quick-start-safeguards`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponseQuickStartSafeguardListResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    quickStartSafeguardList(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.quickStartSafeguardListRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    safeAllSafeguardsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling safeAllSafeguards.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling safeAllSafeguards.');
            }
            if (requestParameters.safeguardBulkSaveRequest === null || requestParameters.safeguardBulkSaveRequest === undefined) {
                throw new runtime.RequiredError('safeguardBulkSaveRequest', 'Required parameter requestParameters.safeguardBulkSaveRequest was null or undefined when calling safeAllSafeguards.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/safeguards`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: SafeguardBulkSaveRequestToJSON(requestParameters.safeguardBulkSaveRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponseSafeguardBulkSaveResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    safeAllSafeguards(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.safeAllSafeguardsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    safeguardDetailsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling safeguardDetails.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling safeguardDetails.');
            }
            if (requestParameters.cdmaSafeguardId === null || requestParameters.cdmaSafeguardId === undefined) {
                throw new runtime.RequiredError('cdmaSafeguardId', 'Required parameter requestParameters.cdmaSafeguardId was null or undefined when calling safeguardDetails.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/safeguards/{cdmaSafeguardId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))).replace(`{${"cdmaSafeguardId"}}`, encodeURIComponent(String(requestParameters.cdmaSafeguardId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponseSafeguardDetailsResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    safeguardDetails(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.safeguardDetailsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    safeguardGroupFiltersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling safeguardGroupFilters.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling safeguardGroupFilters.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/safeguards/safeguard-group-filters`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiListResponseSafeguardGroupFilterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    safeguardGroupFilters(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.safeguardGroupFiltersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    safeguardListRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling safeguardList.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling safeguardList.');
            }
            if (requestParameters.groupIds === null || requestParameters.groupIds === undefined) {
                throw new runtime.RequiredError('groupIds', 'Required parameter requestParameters.groupIds was null or undefined when calling safeguardList.');
            }
            if (requestParameters.orderBy === null || requestParameters.orderBy === undefined) {
                throw new runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling safeguardList.');
            }
            const queryParameters = {};
            if (requestParameters.groupIds) {
                queryParameters['groupIds'] = requestParameters.groupIds;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/safeguards`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponseSafeguardListResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    safeguardList(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.safeguardListRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateSafeguardRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
                throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateSafeguard.');
            }
            if (requestParameters.cdmaId === null || requestParameters.cdmaId === undefined) {
                throw new runtime.RequiredError('cdmaId', 'Required parameter requestParameters.cdmaId was null or undefined when calling updateSafeguard.');
            }
            if (requestParameters.cdmaSafeguardId === null || requestParameters.cdmaSafeguardId === undefined) {
                throw new runtime.RequiredError('cdmaSafeguardId', 'Required parameter requestParameters.cdmaSafeguardId was null or undefined when calling updateSafeguard.');
            }
            if (requestParameters.updateSafeguardAttributeValueRequest === null || requestParameters.updateSafeguardAttributeValueRequest === undefined) {
                throw new runtime.RequiredError('updateSafeguardAttributeValueRequest', 'Required parameter requestParameters.updateSafeguardAttributeValueRequest was null or undefined when calling updateSafeguard.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/v1/org/{organizationId}/cra/cdmas/{cdmaId}/safeguards/{cdmaSafeguardId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"cdmaId"}}`, encodeURIComponent(String(requestParameters.cdmaId))).replace(`{${"cdmaSafeguardId"}}`, encodeURIComponent(String(requestParameters.cdmaSafeguardId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateSafeguardAttributeValueRequestToJSON(requestParameters.updateSafeguardAttributeValueRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiEmptyResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    updateSafeguard(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateSafeguardRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
 * @export
 */
export const SafeguardListOrderByEnum = {
    FrameworkOrder: 'FRAMEWORK_ORDER',
    LargestImpact: 'LARGEST_IMPACT',
    MaximumImpact: 'MAXIMUM_IMPACT'
};
